import React from "react";
// Customer Page

// Default
import { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  Background,
  ReactFlow,
  addEdge,
  useEdgesState,
  useNodesState,
  Handle,
  Position,
} from "@xyflow/react";
import "@xyflow/react/dist/style.css";

// Mui
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";

// Custom
import CustomToast from "../../components/toast/CustomToast";
import ContainedButton from "../../forms/button/ContainedButton";
import ConsumerModal from "../modals/ConsumerModal";
import CommitmentContractModal from "../modals/CommitmentContractModal";
import ConsumerLocationModal from "../modals/ConsumerLocationModal";
import ConsumerSiteModal from "../modals/ConsumerSiteModal";
import CustomSearch from "../../components/search/Search";
import ConsumerManagementModal from "../modals/ConsumerManagementModal";
import AddCustomFieldsDrawer from "../drawer/AddCustomFieldsDrawer";
import CustomFieldsModal from "../modals/CustomFieldsModal";

// Utils
import { fetchGETRequest } from "../../utils/services";
import { formatDate, formatTime, getTimeStamp } from "../../utils/helper";
import { useCustomFields } from "../../context/CustomFieldsProvider";

// Redux
import {
  Divider,
  Grid2 as Grid,
  TableCell,
  TableRow,
  IconButton,
  TextField,
  Grid2,
  CardContent,
  Chip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import CustomDataTable from "../table/CustomTable";
import CreateConsumerModel from "../modals/CreateConsumerModel";
import EditConsumerModel from "../modals/EditConsumerModel";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { ConsumerTableDataT, searchApiResT, ToastState } from "../../types";
import CustomDataTable2 from "../table/CustomeTable2";
import Icon360 from "../../assets/svg/360";
import {
  setCustomerDetails,
  setCustomerId,
  setHasSearched,
  setIsCustomerLoading,
  setCustomerV2Details,
} from "../../redux/features/CustomerSlice";
import {
  setTotalMeters,
  setAllMeters as setAllMetersSlice,
} from "../../redux/features/MeterSlice";
import Calendar2 from "../../assets/svg/calendar2";
import Download from "../../assets/svg/download";
import Share from "../../assets/svg/share";
import { Mic, PlusIcon, Search } from "lucide-react";
import TimeLineSvg from "../../assets/svg/Timeline";
import QueryStatsSvg from "../../assets/svg/QueryStats";
import DataUsageSvg from "../../assets/svg/DataUsage";
import DateAndTimePopover from "../popovers/DateAndTimePopover";
import moment from "moment";
import "moment-timezone";


const COLUMNS2 = [
  "#",
  "Name",
  "Code",
  "Email",
  "Phone",
  "Billing Freq",
  "Billing Level",
  "Contracts",
  "Sites",
  "Active",
  "Actions",
];

const startOfDayIST = moment().tz("Asia/Kolkata").startOf("day").valueOf();
const endOfDayIST = moment().tz("Asia/Kolkata").endOf("day").valueOf();

const CustomerMock: React.FC = () => {
  const [DATA, SetDATA] = useState([]);

  const [hasSearched, setHasSearch] = useState(false);

  const dispatch = useAppDispatch();
  const [pagination, setPagination] = useState({
    currentPage: 0,
    totalPage: 0,
    totalElement: 0,
    pageSize: 10,
  });
  const [openModal, setOpenModal] = useState<{
    type: string;
    id: string;
  }>({
    type: "",
    id: "",
  });
  const [detailModal, setDetailModal] = useState<{
    type: string;
    open: boolean;
  }>({
    type: "",
    open: false,
  });
  const [toast, setToast] = useState<ToastState>({
    message: "",
    severity: "",
  });
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const [allData, setAllData] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState<{
    value: string;
    forwardCursor: number;
    backwardCursor: number;
    pageSize: number;
    showSearch: boolean;
    loading: boolean;
  }>({
    value: "",
    forwardCursor: 0,
    backwardCursor: 0,
    pageSize: 10,
    showSearch: false,
    loading: false,
  });

  const [sortConfig, setSortConfig] = useState<{
    key: "name" | "code" | null;
    direction: "asc" | "desc";
  }>({
    key: null,
    direction: "asc",
  });

  const [startDate, setStartDate] = useState<Date>(new Date());
  const [endDate, setEndDate] = useState<Date>(new Date());
  const [allMeters, setAllMeters] = useState<any[]>([]);

  const [timeRange, setTimeRange] = useState<number[]>([0, 1439]);
  const [timeStamp, setTimeStamp] = useState({
    start: startOfDayIST,
    end: endOfDayIST,
  });
  const [mainSearchValue, setMainSearchValue] = useState<string>("");
  const [selectedNode, setSelectedNode] = useState<any[]>([]);
  const [consumer, setConsumer] = useState<any[]>([]);
  const [activeNode, setActiveNode] = useState<string | null>(null);
  const [searchData, setSearchData] = useState<ConsumerTableDataT[]>([]);

  const [showFlow, setShowFlow] = useState(false);
  const [addOrEdit, setAddOrEdit] = useState<"add" | "edit" | null>(null);

  const [consumerLoader, setConsumerLoader] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const { customFieldId } = useAppSelector((state) => state.auth);

  const { setCreatedFields } = useCustomFields();

  const fetchCustomers = async () => {
    try {
      const customerResponse = await fetchGETRequest(`v2/Customers`, {});
      const transformedArray = customerResponse?.data || [];

      console.log("-----", transformedArray, customerResponse);

      SetDATA(transformedArray);
      // const totalElement =
      //   Number(customerResponse.totalElements) ||
      //   Number(transformedArray.length);

      setPagination((old) => ({
        ...old,
        totalElement: transformedArray.length,
      }));

      // const getSites = await fetchGETRequest(
      //   `tenant/assetInfos?pageSize=10&page=0`,
      //   {}
      // );

      // const getMeters = await fetchGETRequest(
      //   `tenant/deviceInfos?pageSize=10&page=0`,
      //   {}
      // );

      // console.log("-----", customerResponse, getSites, getMeters);
    } catch (error) {
      console.error("Error fetching customers:", error);
      SetDATA([]);
      setToast({
        message: "Error fetching customers. Please try again.",
        severity: "error",
      });
    }
  };

  const fetchSerachConsumer = useCallback(
    async (
      searchValueParam?: typeof searchValue,
      direction: "forward" | "reverse" = "forward",
    ) => {
      const valueToUse = searchValueParam || searchValue;

      console.log("---fetchSerachConsumer---", valueToUse.value);
      setSearchValue((old) => ({
        ...old,
        showSearch: true,
        loading: true,
      }));
      const cursor =
        direction === "forward"
          ? valueToUse.forwardCursor
          : valueToUse.backwardCursor;

      console.log(cursor, valueToUse.value, "---cursor---");

      try {
        const customerResponse = await fetchGETRequest<searchApiResT>(
          `v2/Customers/search?name=${valueToUse.value}&cursor=${cursor}&pageSize=${valueToUse.pageSize}`,
          {},
        );

        const basicResults = customerResponse?.results || [];

        // Fetch full details for each result to get missing fields like customerCode
        const fullDetailsResponses = await Promise.all(
          basicResults.map((res) =>
            fetchGETRequest(`v2/Customers/${res.id}`).catch(() => null),
          ),
        );

        const enrichedResults: any[] = basicResults.map((res, index) => {
          const detailRes = fullDetailsResponses[index] as any;
          const fullData = detailRes?.success ? detailRes.data : {};
          const additionalInfo = JSON.parse(res.additionalInfoJson || "{}");

          return {
            ...res,
            ...fullData,
            additionalInfo,
          };
        });

        setSearchData(enrichedResults);
        setSearchValue((old) => ({
          ...old,
          forwardCursor: customerResponse.nextCursor,
          backwardCursor: customerResponse.previousCursor,
          showSearch: true,
          loading: false,
        }));

        // Update URL with search results view
        setSearchParams({ view: "results", q: valueToUse.value });
      } catch (error) {
        console.error("Error fetching customers:", direction, error);
        setSearchData([]);
        setSearchValue((old) => ({
          ...old,
          forwardCursor: 0,
          backwardCursor: 0,
          showSearch: false,
          loading: false,
        }));
        setToast({
          message: "Error search customers. Please try again.",
          severity: "error",
        });
      }
    },
    [setSearchParams, sortConfig],
  );

  // Restore search state from URL params on mount
  useEffect(() => {
    const view = searchParams.get("view");
    const query = searchParams.get("q");

    // If URL has view=results&q=<query>, restore the search results
    if (view === "results" && query) {
      const restoredSearchValue = {
        ...searchValue,
        value: query,
        forwardCursor: 0,
        backwardCursor: 0,
      };
      setSearchValue(restoredSearchValue);
      setMainSearchValue(query);
      fetchSerachConsumer(restoredSearchValue);
    }
  }, []); // Run only on mount

  useEffect(() => {
    fetchCustomers();
  }, [pagination.currentPage, pagination.pageSize]);

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setPagination((old) => ({
      ...old,
      pageSize: newRowsPerPage,
      currentPage: 0,
    }));
  };

  const handleEditConsumer = (consumerId: string) => {
    setOpenModal({ type: "EDITCONSUMER", id: consumerId });
  };

  const handleSort = (key: "name" | "code") => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const sortedDisplayData = React.useMemo(() => {
    if (!searchData || searchData.length === 0) return [];
    if (!sortConfig.key) return searchData;

    return [...searchData].sort((a, b) => {
      let valA = "";
      let valB = "";

      if (sortConfig.key === "name") {
        valA = String(a?.title || a?.name || "");
        valB = String(b?.title || b?.name || "");
      } else if (sortConfig.key === "code") {
        valA = String(a?.customerCode || (a as any)?.code || "");
        valB = String(b?.customerCode || (b as any)?.code || "");
      }

      const comparison = valA.localeCompare(valB, undefined, {
        numeric: true,
        sensitivity: "base",
      });
      return sortConfig.direction === "asc" ? comparison : -comparison;
    });
  }, [searchData, sortConfig]);

  const sortedTableData = React.useMemo(() => {
    if (!DATA || DATA.length === 0) return [];
    if (!sortConfig.key) return DATA;

    return [...DATA].sort((a: any, b: any) => {
      let valA = "";
      let valB = "";

      if (sortConfig.key === "name") {
        valA = String(a?.title || a?.name || "");
        valB = String(b?.title || b?.name || "");
      } else if (sortConfig.key === "code") {
        valA = String(a?.customerCode || a?.code || "");
        valB = String(b?.customerCode || b?.code || "");
      }

      const comparison = valA.localeCompare(valB, undefined, {
        numeric: true,
        sensitivity: "base",
      });
      return sortConfig.direction === "asc" ? comparison : -comparison;
    });
  }, [DATA, sortConfig]);

  const SortableHeader = ({
    label,
    sortKey,
  }: {
    label: string;
    sortKey: "name" | "code";
  }) => (
    <Stack
      direction="row"
      alignItems="center"
      gap={0.5}
      sx={{ cursor: "pointer", userSelect: "none" }}
      onClick={() => handleSort(sortKey)}
    >
      <Typography variant="body2" fontWeight={700}>
        {label}
      </Typography>
      {sortConfig.key === sortKey && (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {sortConfig.direction === "asc" ? (
            <ArrowUpwardIcon sx={{ fontSize: "14px" }} />
          ) : (
            <ArrowDownwardIcon sx={{ fontSize: "14px" }} />
          )}
        </Box>
      )}
    </Stack>
  );

  const COLUMNS_DYNAMIC = [
    "#",
    <SortableHeader label="Name" sortKey="name" />,
    <SortableHeader label="Code" sortKey="code" />,
    "Email",
    "Phone",
    "Billing Freq",
    "Billing Level",
    "Contracts",
    "Sites",
    "Active",
    "Actions",
  ];

  const COLUMNS2_DYNAMIC = [
    "#",
    <SortableHeader label="Name" sortKey="name" />,
    <SortableHeader label="Code" sortKey="code" />,
    "Email",
    "Phone",
    "Billing Freq",
    "Billing Level",
    "Contracts",
    "Sites",
    "Active",
    "Actions",
  ];

  const CustomNode = ({ data }: { data: any }) => {
    return (
      <Card
        sx={{
          width: "170px",
          borderRadius: "8px",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
          overflow: "hidden",
          backgroundColor: "#FFFFFF",
          border: activeNode === data?.title ? "2px solid #1976d2" : "",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            textAlign: "center",
            padding: "5px",
            background: "linear-gradient(180deg, #1976d2 0%, #0396FF 100%)",
          }}
        >
          <Typography variant="body2" color="#FFFFFF" fontWeight={600}>
            {data?.title}
          </Typography>
        </Box>

        <Stack
          padding={"5px"}
          sx={{ backgroundColor: activeNode === data?.title ? "#edf4f7" : "" }}
          textAlign={"center"}
        >
          {data?.values?.map((item: any, index: number) => {
            return (
              <Stack key={index} direction={"column"} gap={"5px"}>
                <Typography variant="body2" fontSize={"8px"}>
                  <Typography fontSize={"8px"} fontWeight={600}>
                    {data?.label[index]}:{" "}
                  </Typography>
                  {Array.isArray(item) ? (
                    item?.map((subItem, subIndex) => (
                      <Typography
                        key={subIndex}
                        fontSize={"8px"}
                        sx={{ marginLeft: "5px" }}
                      >
                        {subItem}
                      </Typography>
                    ))
                  ) : (
                    <Typography fontSize={"8px"}>{item}</Typography>
                  )}
                </Typography>
              </Stack>
            );
          })}

          <Typography fontSize={"8px"}>
            <Link
              href="#"
              color={"#1280E7"}
              sx={{
                fontSize: "8",
                textAlign: "center",
                fontWeight: 500,
              }}
            >
              {data?.link}
            </Link>
          </Typography>
        </Stack>

        {/* Handles */}
        <Handle type="source" position={Position.Bottom} />
        <Handle
          type="target"
          position={data?.title === "Site" ? Position.Left : Position.Top}
        />
      </Card>
    );
  };

  const CustomCreateNode = ({ data }: { data: any }) => {
    return (
      <Card
        sx={{
          width: "170px",
          borderRadius: "8px",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
          overflow: "hidden",
          backgroundColor: "#FFFFFF",
          border: data?.created
            ? activeNode === data?.title
              ? "2px solid #43E97B"
              : ""
            : activeNode === data?.title
              ? "2px solid #1976d2"
              : "",
          minHeight: "80px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            textAlign: "center",
            padding: "5px",
            background: data?.created
              ? "linear-gradient(180deg, #43E97B 0%, #38D39F 100%)"
              : "linear-gradient(180deg, #1976d2 0%, #0396FF 100%)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" color="#FFFFFF" fontWeight={600}>
            {data?.title}
          </Typography>
        </Box>

        {/* Content */}
        <Stack
          padding={"5px"}
          sx={{
            backgroundColor: activeNode === data?.title ? "#edf4f7" : "#FFFFFF",
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" fontSize={"8px"}>
            {data?.label}&nbsp;
            {data?.link && (
              <Typography fontSize={"8px"}>
                <Link
                  href="#"
                  color={"#1280E7"}
                  sx={{
                    fontSize: "8",
                    textAlign: "center",
                    fontWeight: 500,
                  }}
                >
                  {data?.link}
                </Link>
              </Typography>
            )}
          </Typography>
        </Stack>

        {/* Handles */}
        <Handle type="source" position={Position.Bottom} />
        <Handle
          type="target"
          position={data?.title === "Site" ? Position.Left : Position.Top}
        />
      </Card>
    );
  };

  const nodeTypes = {
    CustomNode: CustomNode,
    CustomCreateNode: CustomCreateNode,
  };

  const [nodes, setNodes, onNodesChange] = useNodesState<any>([]);

  const [edges, setEdges, onEdgesChange] = useEdgesState([
    { id: "e1", source: "Consumer", target: "Contract", animated: true },

    { id: "e2", source: "Contract", target: "Site", animated: true },

    { id: "e3", source: "Location", target: "Site", animated: true },

    { id: "e4", source: "Site", target: "Meter", animated: true },
  ]);

  const handleSelectedNode = (node: any) => {
    switch (node?.id?.toUpperCase()) {
      case "CONSUMER":
        setSelectedNode(consumer);
        setDetailModal({
          type: node?.id?.toUpperCase(),
          open: true,
        });
        setActiveNode(node?.id);
        return;
      case "CONTRACT":
        const contractData = allData?.filter(
          (item: any) => item?.type === "CONTRACT",
        );
        setSelectedNode(contractData);
        setDetailModal({
          type: node?.id?.toUpperCase(),
          open: true,
        });
        setActiveNode(node?.id);
        return;
      case "LOCATION":
        const locationData = allData?.filter(
          (item: any) => item?.type === "LOCATION",
        );
        setSelectedNode(locationData);
        setDetailModal({
          type: node?.id?.toUpperCase(),
          open: true,
        });
        setActiveNode(node?.id);
        return;
      case "SITE":
        const siteData = allData?.filter((item: any) => item?.type === "SITE");
        setSelectedNode(siteData);
        setDetailModal({
          type: node?.id?.toUpperCase(),
          open: true,
        });
        setActiveNode(node?.id);
        return;
      default:
        setSelectedNode(allMeters);
        setDetailModal({
          type: node?.id?.toUpperCase(),
          open: true,
        });
        setActiveNode(node?.id);
    }
  };

  const onConnect = useCallback(
    (connection: any) => setEdges((eds) => addEdge(connection, eds)),
    [setEdges],
  );

  const handleCustomerAndAssetSearch = async (payload?: string) => {
    setConsumerLoader(true);
    let searchTerm = searchValue || payload;

    const customerResponse = await fetchGETRequest(
      `v2/Customers/${searchTerm}`,
      {},
      true,
    );

    const { data: customerData } = customerResponse?.data;
    const { id } = customerData || {};

    setConsumer([customerData]);

    const response = await fetchGETRequest(
      `customer/${searchTerm}/assets?pageSize=10&page=0`,
      {},
      true,
    );

    const nodesArray = [];

    if (customerData) {
      const { name, title, phone, email } = customerData;

      nodesArray.push({
        id: "Consumer",
        position: { x: 100, y: 50 },
        type: "CustomNode",
        data: {
          values: [name || title, phone, email],
          label: ["Name", "Phone", "Email"],
          title: "Consumer",
        },
      });

      if (response?.data?.data && response?.data?.data?.length > 0) {
        setAllData([...response?.data?.data]);

        const contractFilter = response?.data?.data?.filter(
          (item: any) => item?.type === "CONTRACT",
        );

        nodesArray.push({
          id: "Contract",
          type: "CustomNode",
          position: { x: 100, y: 180 },
          data: {
            values: [contractFilter.length],
            label: ["Total Contract"],
            link: "View more Contracts",
            title: "Contract",
          },
        });

        const locationFilter = response?.data?.data?.filter(
          (item: any) => item?.type === "LOCATION",
        );

        nodesArray.push({
          id: "Location",
          position: { x: 300, y: 50 },
          type: "CustomNode",
          data: {
            values: [locationFilter?.length],
            label: ["Total Location"],
            link: "View more Locations",
            title: "Location",
          },
        });

        const siteFilter = response?.data?.data?.filter(
          (item: any) => item?.type === "SITE",
        );

        nodesArray.push({
          id: "Site",
          position: { x: 300, y: 180 },
          type: "CustomNode",
          data: {
            values: [siteFilter?.length],
            label: ["Total Site"],
            link: "View more Sites",
            title: "Site",
          },
        });
      }

      setShowFlow(true);
      setNodes([...nodesArray]);
    } else {
      setToast({ message: "Consumer not found", severity: "error" });
    }

    setConsumerLoader(false);
  };

  const createNewFlow = () => {
    const nodesArray = [];
    setShowFlow(true);
    nodesArray.push({
      id: "Consumer",
      position: { x: 100, y: 50 },
      type: "CustomCreateNode",
      data: {
        label: "To create a new Consumer,",
        link: "click here",
        title: "Consumer",
        created: false,
      },
    });
    nodesArray.push({
      id: "Contract",
      position: { x: 100, y: 180 },
      type: "CustomCreateNode",
      data: {
        label: "To create a new Contract,",
        link: "click here",
        title: "Contract",
        created: false,
      },
    });
    nodesArray.push({
      id: "Location",
      position: { x: 300, y: 50 },
      type: "CustomCreateNode",
      data: {
        label: "To create a new Location,",
        link: "click here",
        title: "Location",
        created: false,
      },
    });
    nodesArray.push({
      id: "Site",
      position: { x: 300, y: 180 },
      type: "CustomCreateNode",
      data: {
        label: "To create a new Site,",
        link: "click here",
        title: "Site",
        created: false,
      },
    });
    nodesArray.push({
      id: "Meter",
      position: { x: 300, y: 300 },
      type: "CustomCreateNode",
      data: {
        label: "To create a new Meter,",
        link: "click here",
        title: "Meter",
        created: false,
      },
    });
    setNodes([...nodesArray]);
  };

  useEffect(() => {
    if (location?.state?.consumerId) {
      setSearchValue({ ...searchValue, value: location?.state?.consumerId });
      // handleCustomerSearch(location?.state?.consumerId)
    }
  }, [location]);

  useEffect(() => {
    if (allData?.length > 0) {
      const fetchMeters = async () => {
        let allActiveMeters: any[] = [];
        const siteData = allData?.filter((item: any) => item?.type === "SITE");

        siteData?.forEach((site) => {
          allActiveMeters = [
            ...allActiveMeters,
            ...site?.additionalInfo?.activeMeters,
          ];
        });

        const allMeters = allActiveMeters.filter((item) => item);

        const responses = await Promise.all(
          allMeters?.map((item) => fetchGETRequest(`device/${item}`, {}, true)),
        );

        const meters = responses?.map((res) => res?.data);

        setAllMeters([...meters]);

        setNodes([
          ...nodes,
          {
            id: "Meter",
            position: { x: 300, y: 300 },
            type: "CustomNode",
            data: {
              values: [meters?.length],
              label: ["Total Meter"],
              link: "View more Meters",
              title: "Meter",
            },
          },
        ]);
      };

      fetchMeters();
    }
  }, [allData]);

  const handleSearchConsumer360 = async (customerId: string) => {
    console.log(customerId, "---customerId---");
    dispatch(setCustomerId(customerId));

    // Update URL with consumer details view
    setSearchParams({ view: "details", id: customerId });

    try {
      dispatch(setIsCustomerLoading(true));

      const [responseLeft, responseRight] = await Promise.all([
        fetchGETRequest(`v2/Customers/${customerId}`),
        fetchGETRequest(`v2/Meters/by-customer/${customerId}`),
      ]);

      if (responseLeft?.status === 400 || responseLeft?.status === 404) {
        setTimeout(() => {
          dispatch(setIsCustomerLoading(false));
          setToast({ message: "Consumer not found", severity: "error" });
        }, 3000);
        return;
      }

      if (responseLeft?.success) {
        dispatch(setCustomerDetails(responseLeft.data));
        dispatch(setCustomerV2Details(responseLeft.data));
      }

      if (responseRight?.data?.length > 0) {
        dispatch(setTotalMeters(responseRight.data?.length));

        const sortedData = responseRight.data.slice().reverse();

        dispatch(setAllMetersSlice(sortedData));

        //  await getMeterConnectionStatus(sortedData?.[0]?.id?.id);
        //  await getTimeSeriesOfMeter(sortedData?.[0]?.id?.id);
      } else {
        dispatch(setAllMetersSlice([]));
        dispatch(setTotalMeters(0));
      }

      // setTimeout(() => {
      dispatch(setHasSearched(true));
      dispatch(setIsCustomerLoading(false));
      // }, 3000);
    } catch (error: any) {
      dispatch(setIsCustomerLoading(false));
      setToast({ message: error.message, severity: "error" });
    }
  };

  const handleCreateNode = (node: any) => {
    switch (node?.id?.toUpperCase()) {
      case "CONSUMER":
        setOpenModal({
          type: node?.id?.toUpperCase(),
          id: node?.data?.value,
        });
        setActiveNode(node?.id);
        return;
      case "CONTRACT":
        setOpenModal({
          type: node?.id?.toUpperCase(),
          id: node?.data?.value,
        });
        setActiveNode(node?.id);
        return;
      case "LOCATION":
        setOpenModal({
          type: node?.id?.toUpperCase(),
          id: node?.data?.value,
        });
        setActiveNode(node?.id);
        return;
      case "SITE":
        setOpenModal({
          type: node?.id?.toUpperCase(),
          id: node?.data?.value,
        });
        setActiveNode(node?.id);
        return;
      case "METER":
        navigate("/meters");
        setActiveNode(node?.id);
        return;
      default:
        setOpenModal({
          type: node?.id?.toUpperCase(),
          id: "",
        });
        setActiveNode(node?.id);
    }
  };

  const fetchCustomFields = async () => {
    try {
      const response = await fetchGETRequest(
        `asset/${customFieldId}`,
        {},
        true,
      );

      if (response?.data?.additionalInfo) {
        const { customFields } = response?.data?.additionalInfo;
        setCreatedFields(customFields);
      }
    } catch (error: any) {
      console.error("Error fetching consumer:", error.message);
    }
  };

  const handleDateChange = (dates: [Date, Date]) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const handleDateSubmit = () => {
    const startTs = getTimeStamp(formatTime(timeRange[0]), new Date(startDate));
    const endTs = getTimeStamp(formatTime(timeRange[1]), new Date(endDate));

    setTimeStamp({
      start: startTs,
      end: endTs,
    });

    setAnchorEl(null);
  };

  console.log("----searchValue---", DATA);

  const rowsContent = sortedTableData
    ?.slice(
      pagination.currentPage * pagination.pageSize,
      (pagination.currentPage + 1) * pagination.pageSize,
    )
    ?.map((item: any, index: number) => (
      <TableRow key={item.id || index}>
      <TableCell>
        <Typography variant="tableBody">
          {index + pagination.currentPage * pagination.pageSize + 1}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="tableBody">{item?.title || item?.name}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="tableBody" fontWeight={700} color="#1064ED">
          {item?.customerCode || "-"}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="tableBody">{item?.email || "-"}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="tableBody">{item?.phone || "-"}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="tableBody">
          {item?.additionalInfo?.billingFrequency || "-"}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="tableBody">
          {item?.additionalInfo?.billingLevel || "-"}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="tableBody">
          {item?.additionalInfo?.contractIds?.length || 0}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="tableBody">
          {item?.additionalInfo?.siteIds?.length || 0}
        </Typography>
      </TableCell>
      <TableCell>
        <Chip
          label={item?.isActive ? "Yes" : "No"}
          size="small"
          sx={{
            backgroundColor: item?.isActive
              ? "rgba(67, 233, 123, 0.2)"
              : "rgba(255, 0, 0, 0.1)",
            color: item?.isActive ? "#2E7D32" : "#D32F2F",
            fontWeight: 700,
            borderRadius: "6px",
            fontSize: "12px",
          }}
        />
      </TableCell>
      <TableCell>
        <IconButton
          onClick={() => handleEditConsumer(item?.id)}
          title="Edit"
          sx={{
            width: "28px",
            height: "28px",
            "&:hover": {
              backgroundColor: "rgba(31, 189, 255, 0.1)",
            },
          }}
        >
          <EditIcon sx={{ fontSize: "20px" }} />
        </IconButton>
        <IconButton
          onClick={() => handleSearchConsumer360(item?.id)}
          title="Consumer-360"
          sx={{
            width: "28px",
            height: "28px",
            "&:hover": {
              backgroundColor: "rgba(31, 189, 255, 0.1)",
            },
          }}
        >
          <Icon360 />
        </IconButton>
      </TableCell>
    </TableRow>
  ));

  const searchResultsRows = sortedDisplayData?.map((item, index: number) => (
    <TableRow key={item.id || index}>
      <TableCell>
        <Typography variant="tableBody">{index + 1}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="tableBody" fontWeight={600}>
          {item?.title || item?.name}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="tableBody" fontWeight={700} color="#1064ED">
          {item?.customerCode || "-"}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="tableBody">
          {item?.email || item?.additionalInfo?.emailId || "-"}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="tableBody">
          {item?.phone || item?.additionalInfo?.mobileNumber || "-"}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="tableBody">
          {item?.additionalInfo?.billingFrequency || "-"}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="tableBody">
          {item?.additionalInfo?.billingLevel || "-"}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="tableBody">
          {item?.additionalInfo?.contractIds?.length || 0}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="tableBody">
          {item?.additionalInfo?.siteIds?.length || 0}
        </Typography>
      </TableCell>
      <TableCell>
        <Chip
          label={
            item?.additionalInfo?.status === "active" || item?.isActive
              ? "Yes"
              : "No"
          }
          size="small"
          sx={{
            backgroundColor:
              item?.additionalInfo?.status === "active" || item?.isActive
                ? "rgba(67, 233, 123, 0.2)"
                : "rgba(255, 0, 0, 0.1)",
            color:
              item?.additionalInfo?.status === "active" || item?.isActive
                ? "#2E7D32"
                : "#D32F2F",
            fontWeight: 700,
            borderRadius: "6px",
            fontSize: "12px",
          }}
        />
      </TableCell>
      <TableCell>
        <IconButton
          onClick={() => handleEditConsumer(item?.id)}
          title="Edit"
          sx={{
            width: "28px",
            height: "28px",
            "&:hover": {
              backgroundColor: "rgba(31, 189, 255, 0.1)",
            },
          }}
        >
          <EditIcon sx={{ fontSize: "20px" }} />
        </IconButton>
        <IconButton
          onClick={() => handleSearchConsumer360(item?.id)}
          title="Consumer-360"
          sx={{
            width: "28px",
            height: "28px",
            "&:hover": {
              backgroundColor: "rgba(31, 189, 255, 0.1)",
            },
          }}
        >
          <Icon360 />
        </IconButton>
      </TableCell>
    </TableRow>
  ));

  const cardData = [
    {
      id: 1,
      title: "Total Consumers",
      total: 4980,
      details: [
        { label: "Connected Consumers", value: 4850 },
        { label: "Disconnected Consumers", value: 130 },
      ],
      footer: {
        icon: <TimeLineSvg width={20} height={19} />,
        date: "14 Oct.'25 10:53:52 am",
        label: "Anomaly Data",
      },
    },
    {
      id: 2,
      title: "Total Active Consumers",
      total: 4850,
      details: [
        { label: "Investigated Consumers", value: 4450 },
        { label: "Investigation Needed", value: 400 },
      ],
      footer: {
        icon: <QueryStatsSvg width={19} height={19} />,
        label: "Investigate Usage",
        subLabel: "Anomaly Data",
      },
    },
    {
      id: 3,
      title: "Avg. Usage/month (total)",
      total: "747,000",
      span: "kWh",
      details: [
        { label: "Avg. Usage/day (total)", value: "24,900 kWh" },
        { label: "Avg. Usage/hour (total)", value: "1,037.5 kWh" },
      ],
      footer: {
        icon: <DataUsageSvg width={20} height={19} />,
        date: "14 Oct.'25",
        label: "Last Calculated Data",
      },
    },
  ];

  return (
    <Box>
      {!hasSearched && !showFlow && (
        <Box
          sx={{
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            mx: "auto",
            mt: "5%",
          }}
        >
          <Stack
            sx={{
              width: "100%",
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography variant="h4" fontWeight={700} fontSize={"33px"}>
              Hello, John
            </Typography>
            <Typography fontSize={"16px"} fontWeight={500} color="#6F767C">
              Customer Management 360 streamlines your customer data for smarter
              decisions.{" "}
            </Typography>
          </Stack>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #D3E3FD", // Blue border
              borderRadius: "40px",
              padding: "4px 10px",
              width: "80%",
              maxWidth: 800,
              mx: "auto",
              backgroundColor: "#FFFFFF",
              boxShadow: "0 0 3px rgba(33,150,243,0.3)",
              my: "20px",
            }}
          >
            {/* Left Icon */}
            <IconButton
              sx={{ color: "#000" }}
              onClick={() => {
                setOpenModal({ type: "CREATENEW", id: "" });
              }}
            >
              <PlusIcon size={15} />
            </IconButton>
            <Divider
              orientation="vertical"
              sx={{
                height: "24px",
                width: "1px",
                backgroundColor: "#D3E3FD",
                mx: "10px",
              }}
            />

            {/* Input Field */}
            <TextField
              variant="standard"
              placeholder="Search Consumer by ID, Name, Contact Number or Location"
              fullWidth
              InputProps={{
                disableUnderline: true,
              }}
              sx={{
                ml: 1,
                "& input::placeholder": {
                  color: "#888",
                  opacity: 1,
                  fontSize: "12px",
                },
                fontSize: "12px",
              }}
              onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                if (e.key === "Enter") {
                  const newSearchValue = {
                    value: mainSearchValue,
                    forwardCursor: 0,
                    backwardCursor: 0,
                    pageSize: searchValue.pageSize,
                    showSearch: searchValue.showSearch,
                    loading: searchValue.loading,
                  };
                  setSearchValue((old) => ({
                    ...old,
                    value: mainSearchValue,
                    forwardCursor: 0,
                    backwardCursor: 0,
                  }));

                  setHasSearch(true);

                  setTimeout(() => {
                    fetchSerachConsumer(newSearchValue);
                  }, 300);
                }
              }}
              value={mainSearchValue}
              onChange={(e) => setMainSearchValue(e.target.value)}
            />

            {/* Right Icon */}
            <IconButton
              sx={{ color: "#000" }}
              onClick={() => {
                const newSearchValue = {
                  value: mainSearchValue,
                  forwardCursor: 0,
                  backwardCursor: 0,
                  pageSize: searchValue.pageSize,
                  showSearch: searchValue.showSearch,
                  loading: searchValue.loading,
                };
                setSearchValue((old) => ({
                  ...old,
                  value: mainSearchValue,
                  forwardCursor: 0,
                  backwardCursor: 0,
                }));

                setHasSearch(true);

                setTimeout(() => {
                  fetchSerachConsumer(newSearchValue);
                }, 300);
              }}
            >
              <Search size={15} />
            </IconButton>
          </Box>
          <Box
            sx={{
              padding: "4px",
              width: "80%",
              maxWidth: 800,
              mx: "auto",
              my: "20px",
            }}
          >
            <Stack
              sx={{
                width: "100%",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                flexDirection: "row",
                gap: "10px",
                mb: "20px",
              }}
            >
              <Box
                sx={{
                  fontWeight: 600,
                  letterSpacing: "0.32px",
                  padding: "1px 8px",
                  color: "#ffffff",
                  width: "fit-content",
                }}
              >
                <Stack
                  direction={"row"}
                  justifyContent={"center"}
                  gap={"5px"}
                  alignItems={"center"}
                  px={"5px"}
                >
                  <Typography variant="body2">
                    {formatDate(startDate, "D MMMM YYYY")} -{" "}
                  </Typography>
                  <Typography variant="body2">
                    {formatDate(endDate, "D MMMM YYYY")}
                  </Typography>
                </Stack>
              </Box>

              <IconButton onClick={(event) => setAnchorEl(event.currentTarget)}>
                <Calendar2 />
              </IconButton>
            </Stack>
            <Grid2 container spacing={3}>
              {cardData.map((card, index) => (
                <Grid2 size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                  <Card
                    sx={{
                      borderRadius: 3,
                      boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                      backgroundColor: "#fff",
                    }}
                  >
                    <CardContent>
                      {/* Title and Total */}
                      <Typography
                        variant="body1"
                        fontSize={"20px"}
                        fontWeight={700}
                        lineHeight={"22px"}
                      >
                        {card.total}
                        {card.span && (
                          <span style={{ fontWeight: 400, marginLeft: "4px" }}>
                            {card.span}
                          </span>
                        )}
                      </Typography>
                      <Typography
                        variant="body2"
                        fontSize={"12px"}
                        fontWeight={500}
                      >
                        {card.title}
                      </Typography>

                      {/* Details */}
                      {card.details.map((d, i) => (
                        <Box key={i} mt={3}>
                          <Typography
                            variant="body2"
                            fontSize={"13px"}
                            fontWeight={700}
                            color="#373C42"
                          >
                            {d.value}
                          </Typography>
                          <Typography
                            variant="body2"
                            fontSize={"12px"}
                            color="#373C42"
                          >
                            {d.label}
                          </Typography>
                        </Box>
                      ))}

                      <Divider sx={{ my: 2 }} />

                      {/* Footer */}
                      <Box
                        display="flex"
                        alignItems="center"
                        gap={1}
                        sx={{ p: 0 }}
                      >
                        {card.footer.icon}
                        <Box>
                          <Typography
                            variant="body1"
                            fontWeight={700}
                            fontSize={"13px"}
                            color="#373C42"
                          >
                            {card.footer.label}
                          </Typography>
                          {card.footer.date && (
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              fontSize={"13px"}
                            >
                              {card.footer.date}
                            </Typography>
                          )}
                          {card.footer.subLabel && (
                            <Typography variant="body2" color="text.secondary">
                              {card.footer.subLabel}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid2>
              ))}
            </Grid2>
          </Box>
        </Box>
      )}

      {hasSearched && !showFlow && (
        <Box
          sx={{
            display: "flex",
            width: "100%",
            flexDirection: "column",
          }}
        >
          <Stack
            flexDirection={"row"}
            justifyContent={"space-between"}
            width={"100%"}
            alignItems={"center"}
          >
            <Stack direction={"row"} gap={2}>
              <Card
                sx={{
                  borderRadius: 3,
                  p: 2,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                  backgroundColor: "#fff",
                }}
              >
                <Typography
                  variant="inherit"
                  sx={{ fontWeight: "600", fontSize: "18px" }}
                >
                  4,980{" "}
                </Typography>
                <Typography
                  variant="inherit"
                  sx={{ fontWeight: "500", fontSize: "13px" }}
                >
                  Total Consumers
                </Typography>
              </Card>
              <Card
                sx={{
                  borderRadius: 3,
                  p: 2,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                  backgroundColor: "#fff",
                }}
              >
                <Typography
                  variant="inherit"
                  sx={{ fontWeight: "600", fontSize: "18px" }}
                >
                  4,850{" "}
                </Typography>
                <Typography
                  variant="inherit"
                  sx={{ fontWeight: "500", fontSize: "13px" }}
                >
                  Total Active Consumers
                </Typography>
              </Card>
              <Card
                sx={{
                  borderRadius: 3,
                  p: 2,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                  backgroundColor: "#fff",
                }}
              >
                <Typography
                  variant="inherit"
                  sx={{ fontWeight: "600", fontSize: "18px" }}
                >
                  747,000 kWh
                </Typography>
                <Typography
                  variant="inherit"
                  sx={{ fontWeight: "500", fontSize: "13px" }}
                >
                  Avg. Usage/month (total)
                </Typography>
              </Card>
            </Stack>
            {/* <Typography
              variant="inherit"
              sx={{ fontWeight: "600", fontSize: "20px" }}>
              Consumers{" "}
            </Typography> */}
            <CustomSearch
              placeholder={
                "Search Consumer By Id, Name, Contact Number or Location"
              }
              sx={{
                width: "400px",
                height: "35px",
                backgroundColor: "#5F63680F",
              }}
              value={searchValue?.value}
              onChange={(e) =>
                setSearchValue((old) => ({
                  ...old,
                  value: e.target.value,
                  forwardCursor: 0,
                  backwardCursor: 0,
                  showSearch: e.target.value !== "" ? old.showSearch : false,
                }))
              }
              onClick={() => fetchSerachConsumer(searchValue)}
              onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                if (e.key === "Enter") {
                  fetchSerachConsumer(searchValue);
                }
              }}
            />
            <Stack flexDirection={"row"} gap={3} alignItems={"center"}>
              {/* <Box
                sx={{
                  fontWeight: 600,
                  letterSpacing: "0.32px",
                  padding: "1px 8px",
                  color: "#ffffff",
                  width: "fit-content",
                }}>
                <Stack
                  direction={"row"}
                  justifyContent={"center"}
                  gap={"5px"}
                  alignItems={"center"}
                  px={"5px"}>
                  <Typography>
                    {formatDate(startDate, "D MMMM YYYY")} -{" "}
                  </Typography>
                  <Typography>{formatDate(endDate, "D MMMM YYYY")}</Typography>
                </Stack>
              </Box> */}
              {/* <IconButton>
                <Calendar2 />
              </IconButton>
              <Divider
                sx={{
                  borderWidth: "1px",
                  height: "35px",
                  backgroundColor: "#5F6368",
                  color: "#5F6368",
                }}
              />
              <IconButton>
                <Download />
              </IconButton>
              <IconButton>
                <Share />
              </IconButton> */}
              <ContainedButton
                label={"Create consumer"}
                sx={{
                  width: "fit-content",
                  fontWeight: 600,
                  color: "#ffffff",
                  height: "35px",
                  boxShadow: "0",
                  borderRadius: "5px",
                }}
                onClick={() => {
                  setOpenModal({ type: "CREATENEW", id: "" });
                }}
              />
            </Stack>
          </Stack>
          <Grid container spacing={2.25} sx={{ marginTop: "40px" }}>
            {searchValue.showSearch && searchValue.value.length > 0 ? (
              <Grid size={{ xs: 12 }}>
                <Card
                  sx={{
                    minHeight: "203px",
                    borderRadius: "0px !important",
                  }}
                >
                  <CustomDataTable2
                    // sx={{ maxHeight: "600px" }}
                    columns={COLUMNS2_DYNAMIC}
                    rowsContent={searchResultsRows}
                    rowsPerPage={searchValue.pageSize}
                    rowsPerPageOptions={[10, 50, 100]}
                    onRowsPerPageChange={(e) => {
                      const newSearchValue = {
                        ...searchValue,
                        pageSize: e,
                        forwardCursor: 0,
                        backwardCursor: 0,
                      };
                      setSearchValue(newSearchValue);
                      fetchSerachConsumer(newSearchValue);
                    }}
                    isLoading={searchValue.loading}
                    handleBackButtonClick={() => {
                      fetchSerachConsumer(searchValue, "reverse");
                    }}
                    handleNextButtonClick={() => {
                      fetchSerachConsumer(searchValue, "forward");
                    }}
                  />
                </Card>
              </Grid>
            ) : (
              <Grid size={{ xs: 12 }}>
                <Card
                  sx={{
                    minHeight: "203px",
                    borderRadius: "0px !important",
                  }}
                >
                  <CustomDataTable
                    // sx={{ maxHeight: "600px" }}
                    columns={COLUMNS_DYNAMIC}
                    // rows={DATA}
                    rowsContent={rowsContent}
                    pagination
                    Actions={true}
                    onPageChange={(_, newPage) =>
                      setPagination((old) => ({ ...old, currentPage: newPage }))
                    }
                    rowsPerPage={pagination.pageSize}
                    rowsPerPageOptions={[10, 50, 100]}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    totalCount={pagination.totalElement}
                    page={pagination.currentPage}
                  />
                </Card>
              </Grid>
            )}
          </Grid>
        </Box>
      )}

      {showFlow && (
        <Card
          sx={{
            height: "100vh",
            width: "100%",
            display: "flex",
            justifyContent: "flex-start",
            marginTop: "20px",
          }}
        >
          <div style={{ height: "100%", width: "100%" }}>
            <ReactFlow
              nodes={nodes?.map((node) => ({
                ...node,
                draggable: false,
              }))}
              edges={edges}
              onNodeClick={(_, node) => {
                if (addOrEdit === "add") {
                  handleCreateNode(node);
                } else {
                  handleSelectedNode(node);
                }
              }}
              onEdgesChange={onEdgesChange}
              onConnect={onConnect}
              zoomOnScroll={false}
              fitView
              fitViewOptions={{ padding: 0.2 }}
              onLoad={(instance: any) => {
                instance.fitView({ padding: 0.2, duration: 800 });
                instance.setViewport({ x: 0, y: 0, zoom: 1 });
              }}
              nodeTypes={nodeTypes}
            >
              <Background />
            </ReactFlow>
          </div>
        </Card>
      )}

      <ConsumerModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        setToast={setToast}
        addOrEdit={addOrEdit}
        nodes={nodes}
        setNodes={setNodes}
        handleCustomerAndAssetSearch={handleCustomerAndAssetSearch}
      />

      <CommitmentContractModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        setToast={setToast}
        addOrEdit={addOrEdit}
        nodes={nodes}
        setNodes={setNodes}
        handleCustomerAndAssetSearch={handleCustomerAndAssetSearch}
      />

      <ConsumerLocationModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        setToast={setToast}
        addOrEdit={addOrEdit}
        nodes={nodes}
        setNodes={setNodes}
        handleCustomerAndAssetSearch={handleCustomerAndAssetSearch}
      />

      <ConsumerSiteModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        setToast={setToast}
        addOrEdit={addOrEdit}
        nodes={nodes}
        setNodes={setNodes}
        handleCustomerAndAssetSearch={handleCustomerAndAssetSearch}
      />

      <ConsumerManagementModal
        detailModal={detailModal}
        setDetailModal={setDetailModal}
        selectedNode={selectedNode}
        setOpenModal={setOpenModal}
      />

      <AddCustomFieldsDrawer setToast={setToast} />

      <CustomFieldsModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        setToast={setToast}
        addOrEdit={addOrEdit}
        nodes={nodes}
        setNodes={setNodes}
        handleCustomerAndAssetSearch={handleCustomerAndAssetSearch}
      />

      <CreateConsumerModel
        openModal={{
          id: openModal?.id,
          type: openModal?.type,
          onlyMeter: false,
        }}
        setOpenModal={setOpenModal}
        setToast={setToast}
        addOrEdit={addOrEdit}
        handleCustomerAndAssetSearch={handleCustomerAndAssetSearch}
      />

      <EditConsumerModel
        openModal={{
          id: openModal?.id,
          type: openModal?.type,
          onlyMeter: false,
        }}
        setOpenModal={setOpenModal}
        setToast={setToast}
      />

      <CustomToast
        open={toast?.message}
        severity={toast?.severity}
        setToast={setToast}
      />

      <DateAndTimePopover
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        startDate={startDate}
        endDate={endDate}
        handleDateChange={handleDateChange}
        timeRange={timeRange}
        setTimeRange={(timeRange) =>
          setTimeRange(
            Array.isArray(timeRange) ? timeRange : [timeRange, timeRange],
          )
        }
        handleDateSubmit={handleDateSubmit}
      />
    </Box>
  );
};

export default CustomerMock;
